import React, { useEffect, useState } from 'react';
import {
  Box,
  ButtonIcon,
  Icon,
  MobileDrawer,
  ModalIsland,
  Typography,
} from '@saviynt/design-system';
import PropTypes from 'prop-types';

import { useInvertedLocalize } from '../../../utils/localization';
import { DEFAULT_BULK_ACTION_FOOTER_BTNS } from '../constant';
import { BULK_ACTION_COMMON } from '../mockData';

import BulkActionCommonBody from './BulkActionCommonBody';
import BulkActionCommonFooter from './BulkActionCommonFooter';
import BulkActionCommonHeader from './BulkActionCommonHeader';
import BulkActionCommonSubTitle from './BulkActionCommonSubTitle';
import invertedMessages from './messages';

import './BulkActionCommon.css';

function BulkActionCommon({
  bulkFooterStats,
  bulkActionCommonAction,
  setBulkActionCommonAction,
  handleCommonAction,
  bulkPredefinedComments,
  isMobileXlargeWidth,
}) {
  const [isMobileDrawerOpen, setIsMobileDrawerOpen] = useState(false);

  const l = useInvertedLocalize(invertedMessages);

  const handleCloseBulkActionCommon = () => {
    setBulkActionCommonAction((prev) => ({
      ...prev,
      isOpen: false,
      hasAgreed: false,
      comment: '',
    }));
  };

  const handleCloseBukActionCommonAlert = () => {
    setBulkActionCommonAction((prev) => ({
      ...prev,
      showAlert: false,
    }));
  };

  useEffect(() => {
    if (!isMobileDrawerOpen && isMobileXlargeWidth)
      handleCloseBulkActionCommon();
  }, [isMobileDrawerOpen]);

  useEffect(() => {
    setIsMobileDrawerOpen(bulkActionCommonAction?.isOpen);
  }, [bulkActionCommonAction?.isOpen]);

  // TODO: @Sagar, These classNames are very important to update!!
  if (isMobileXlargeWidth) {
    return (
      <MobileDrawer
        className='BulkActionCommon-mobileDrawer'
        isOpen={isMobileDrawerOpen}
        setIsOpen={setIsMobileDrawerOpen}
        headerContent={
          <div className='ModalIsland-headerWrapper'>
            <div className='ModalIsland-header ModalIsland-header--hasSubtitle ModalIsland-header--hasIcon'>
              {bulkActionCommonAction?.id ===
              DEFAULT_BULK_ACTION_FOOTER_BTNS.TERMINATE.id ? (
                <Icon kind='Terminate' size='large' color='critical-700' />
              ) : (
                <Icon kind='AlertWarningFilledSeparateColors' size='large' />
              )}
              <div className='ModalIsland-titleContainer'>
                <Typography
                  className='ModalIsland-title'
                  kind='h2'
                  desktop='h2-d'
                  mobile='h2-d'>
                  <BulkActionCommonHeader
                    id={bulkActionCommonAction?.id}
                    bulkFooterStats={bulkFooterStats}
                  />
                </Typography>
                <Typography
                  className='ModalIsland-subtitle'
                  kind='body2'
                  desktop='body2-d'
                  mobile='body2-d'>
                  <BulkActionCommonSubTitle
                    id={bulkActionCommonAction?.id}
                    bulkFooterStats={bulkFooterStats}
                  />
                </Typography>
              </div>
            </div>
            <Box tag='div' className='ModalIsland-closeBtn'>
              <ButtonIcon
                size='medium'
                kind='ghost'
                ariaLabel={l('Close')}
                icon={
                  <Icon kind='close' color='neutral-100' size='smallMedium' />
                }
                onClick={() => setIsMobileDrawerOpen(false)}
              />
            </Box>
          </div>
        }
        content={
          <BulkActionCommonBody
            bulkActionCommonAction={bulkActionCommonAction}
            setBulkActionCommonAction={setBulkActionCommonAction}
            handleCloseBukActionCommonAlert={handleCloseBukActionCommonAlert}
            bulkPredefinedComments={bulkPredefinedComments}
            isMobileXlargeWidth={isMobileXlargeWidth}
          />
        }
        footerActionBar={
          <BulkActionCommonFooter
            handleCommonAction={handleCommonAction}
            bulkActionCommonAction={bulkActionCommonAction}
            handleCloseBulkActionCommon={handleCloseBulkActionCommon}
          />
        }
      />
    );
  }

  return (
    <ModalIsland
      className='BulkActionCommon-modal'
      onClose={
        bulkActionCommonAction?.isSubmitting
          ? () => {}
          : handleCloseBulkActionCommon
      }
      isOpen={bulkActionCommonAction?.isOpen}
      headerIcon={
        bulkActionCommonAction?.id ===
        DEFAULT_BULK_ACTION_FOOTER_BTNS.TERMINATE.id ? (
          <Icon kind='Terminate' size='large' color='critical-700' />
        ) : (
          <Icon kind='AlertWarningFilledSeparateColors' size='large' />
        )
      }
      title={
        <BulkActionCommonHeader
          id={bulkActionCommonAction?.id}
          bulkFooterStats={bulkFooterStats}
        />
      }
      subtitle={
        <BulkActionCommonSubTitle
          id={bulkActionCommonAction?.id}
          bulkFooterStats={bulkFooterStats}
        />
      }
      contentBody={
        <BulkActionCommonBody
          bulkActionCommonAction={bulkActionCommonAction}
          setBulkActionCommonAction={setBulkActionCommonAction}
          handleCloseBukActionCommonAlert={handleCloseBukActionCommonAlert}
          bulkPredefinedComments={bulkPredefinedComments}
        />
      }
      FooterActionBarComp={
        <BulkActionCommonFooter
          handleCommonAction={handleCommonAction}
          bulkActionCommonAction={bulkActionCommonAction}
          handleCloseBulkActionCommon={handleCloseBulkActionCommon}
        />
      }
      isOverflowVisible
    />
  );
}

BulkActionCommon.propTypes = {
  bulkFooterStats: PropTypes.shape({}),
  bulkActionCommonAction: PropTypes.shape(BULK_ACTION_COMMON).isRequired,
  setBulkActionCommonAction: PropTypes.func.isRequired,
  handleCommonAction: PropTypes.func.isRequired,
  bulkPredefinedComments: PropTypes.arrayOf(PropTypes.string),
  isMobileXlargeWidth: PropTypes.bool,
};

BulkActionCommon.defaultProps = {
  bulkFooterStats: {},
  bulkPredefinedComments: [],
  isMobileXlargeWidth: false,
};

export default BulkActionCommon;
